import { io, type Socket } from 'socket.io-client';
import { ensureFreshToken } from '@/lib/api/client';

const NAMESPACE = import.meta.env.VITE_SOCKET_PATH ?? '/realtime';
const URL = import.meta.env.VITE_SOCKET_URL ?? `${window.location.origin}${NAMESPACE}`;

let socket: Socket | null = null;

/**
 * One socket for the whole app. The gateway puts the client in a company room
 * on connect, so every consumer listens to the same connection rather than
 * opening its own.
 */
export function getSocket(): Socket {
  socket ??= io(URL, {
    autoConnect: false,
    transports: ['websocket', 'polling'],
    reconnectionAttempts: Infinity,
    reconnectionDelay: 800,
    reconnectionDelayMax: 8_000,
    // Re-evaluated on every connection attempt, so a reconnect after the
    // 15-minute access token has expired refreshes rather than looping.
    auth: (cb) => {
      void ensureFreshToken().then((token) => cb({ token }));
    },
  });
  return socket;
}

export function connectSocket(): Socket {
  const instance = getSocket();
  if (!instance.connected) instance.connect();
  return instance;
}

export function disconnectSocket(): void {
  socket?.removeAllListeners();
  socket?.disconnect();
  socket = null;
}
